var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefazer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5063 23.0001L21 16.6257L14.5063 10.2513L12.1139 12.6206L14.5633 15.0462C13.5 15.0838 12.4656 14.9146 11.46 14.5385C10.4544 14.1625 9.55215 13.5796 8.75316 12.7898C7.99367 12.0377 7.41418 11.1727 7.01468 10.1949C6.61519 9.21716 6.4162 8.23938 6.41772 7.2616C6.41772 6.62228 6.50354 5.98297 6.67519 5.34365C6.84683 4.70434 7.0838 4.08382 7.38607 3.48211L4.87975 1.00006C4.23418 1.94023 3.75949 2.93681 3.45569 3.9898C3.1519 5.0428 3 6.11459 3 7.20519C3 8.63425 3.28481 10.0445 3.85443 11.436C4.42405 12.8274 5.25949 14.0684 6.36076 15.159C7.46202 16.2496 8.6962 17.068 10.0633 17.614C11.4304 18.1601 12.8354 18.4511 14.2785 18.4872L12.1139 20.6308L14.5063 23.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefazer);
export default __webpack_public_path__ + "static/media/Refazer.3c075a7e59b63e08936f8a268ec8af15.svg";
export { ForwardRef as ReactComponent };